import LicenseNumberInputContainer from './LicenseNumberInputContainer';

export default LicenseNumberInputContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/LicenseNumberInput/index.js